var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("group",null,null,{ valid: _vm.valid, invalid: !_vm.valid, validate: _vm.validate })],2)}
var staticRenderFns = []

export { render, staticRenderFns }